export default "__VITE_ASSET__eIpEHnTk__"